import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import Anunt7 from './views/anunt-7'
import Anunt8 from './views/anunt-8'
import Transport from './views/transport'
import Anunt5 from './views/anunt-5'
import News from './views/news'
import Anunt1 from './views/anunt-1'
import Page from './views/page'
import Home from './views/home'
import ParcareAuto from './views/parcare-auto'
import ReparatiiAuto from './views/reparatii-auto'
import DespreNoi from './views/despre-noi'
import AlimentareaPublica from './views/alimentarea-publica'
import Anunt2 from './views/anunt-2'
import ArendaSpatii from './views/arenda-spatii'
import Anunt4 from './views/anunt-4'
import Anunt3 from './views/anunt-3'
import Anunt6 from './views/anunt-6'
import NotFound from './views/not-found'
import './style.css'

Vue.use(Router)
Vue.use(Meta)
export default new Router({
  mode: 'history',
  routes: [
    {
      name: 'Anunt-7',
      path: '/anunt-7',
      component: Anunt7,
    },
    {
      name: 'Anunt-8',
      path: '/anunt-8',
      component: Anunt8,
    },
    {
      name: 'Transport',
      path: '/transport',
      component: Transport,
    },
    {
      name: 'Anunt-5',
      path: '/anunt-5',
      component: Anunt5,
    },
    {
      name: 'News',
      path: '/news',
      component: News,
    },
    {
      name: 'Anunt-1',
      path: '/anunt-1',
      component: Anunt1,
    },
    {
      name: 'Page',
      path: '/404',
      component: Page,
    },
    {
      name: 'Home',
      path: '/',
      component: Home,
    },
    {
      name: 'Parcare-Auto',
      path: '/parcare-auto',
      component: ParcareAuto,
    },
    {
      name: 'Reparatii-Auto',
      path: '/reparatii-auto',
      component: ReparatiiAuto,
    },
    {
      name: 'Despre-Noi',
      path: '/despre-noi',
      component: DespreNoi,
    },
    {
      name: 'Alimentarea-publica',
      path: '/alimentarea-publica',
      component: AlimentareaPublica,
    },
    {
      name: 'Anunt-2',
      path: '/anunt-2',
      component: Anunt2,
    },
    {
      name: 'Arenda-spatii',
      path: '/arenda-spatii',
      component: ArendaSpatii,
    },
    {
      name: 'Anunt-4',
      path: '/anunt-4',
      component: Anunt4,
    },
    {
      name: 'Anunt-3',
      path: '/anunt-3',
      component: Anunt3,
    },
    {
      name: 'Anunt-6',
      path: '/anunt-6',
      component: Anunt6,
    },
    {
      name: '404 - Not Found',
      path: '**',
      component: NotFound,
      fallback: true,
    },
  ],
})
